import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useLeaderBoardUnsubscribeDetails = () => {
    const send = useGenericSend();

    return useCallback(async (options: Types.ILeaderBoardUnsubscribeDetailsRequestData) => {
        const response = await send<
            Types.ILeaderBoardUnsubscribeDetailsRequestData,
            Types.ILeaderBoardUnsubscribeDetailsResponseData
        >({
            ID: 71019,
            responses: [71020, 71021],
            description: 'Unsubscribe from leaderboard details notifications',
            ...options
        });

        return response;
    }, [send]);
};
